import { gql } from '@apollo/client'
import PAGINATED_PAGE_INFO_FRAGMENT from 'apollo/fragments/PAGINATED_PAGE_INFO_FRAGMENT'

// FACILITIES_PAGE

export default gql`
  query facilities_page(
    $cursor: String
    $location_type: FACILITY_LOCATION_TYPE
    $filters: FacilitiesFilterInput
    $member_plan_id: ID
    $member_has_plan: Boolean!
    $employee_id: ID
  ) {
    facilities_v2(
      first: 25
      after: $cursor
      location_type: $location_type
      distance: 100000
      filters: $filters
      employee_id: $employee_id
    ) {
      nodes {
        id
        isFacility @client
        name
        google_maps_link
        latitude
        longitude
        distance
        image_url
        contacts {
          address
          phones
          faxes
          uuid
          confidence
          address_line_1
          address_line_2
          city
          state
          zip
        }
        confirmed
        confirmed_at
        confirmed_by {
          full_name
        }
        location_types
        display_location_types
        insurance_tier(insurance_plan_id: $member_plan_id)
          @include(if: $member_has_plan) {
          name
        }
        uuid
        source
      }
      pageInfo {
        ...PAGINATED_PAGE_INFO_FRAGMENT
      }
    }
  }
  ${PAGINATED_PAGE_INFO_FRAGMENT}
`
